import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Char_wrap$SolvuuLang0 from "./char_wrap.bs.js";

function write_var(write__var) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Var", write__var, x[1]);
  });
}

function read_var(read__var) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Var",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Var */
        [4298439, x]
      );
    }, read__var, param);
  }]],
  /* [] */
  0]);
}

function write_uri(write__uri) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Uri", write__uri, x[1]);
  });
}

function read_uri(read__uri) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Uri",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Uri */
        [4252492, x]
      );
    }, read__uri, param);
  }]],
  /* [] */
  0]);
}

function write_future(write__blob_id, write__job_id) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= 295523485) {
      return Atdgen_codec_runtime.Encode.constr1("Blob_id", write__blob_id, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Job_id", write__job_id, x[1]);
    }
  });
}

function read_future(read__blob_id, read__job_id) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Blob_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Blob_id */
        [295523485, x]
      );
    }, read__blob_id, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Job_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Job_id */
        [-1057852867, x]
      );
    }, read__job_id, param);
  }]],
  /* [] */
  0]]);
}

function write_error(write__blob_id, write__job_id, write__t, write__ty) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant >= 771069884) {
      if (variant >= 937565914) {
        return Atdgen_codec_runtime.Encode.constr1("Type", function (param) {
          return Atdgen_codec_runtime.Encode.tuple3(write__t, function (param) {
            return Atdgen_codec_runtime.Encode.nullable(write__ty, param);
          }, Atdgen_codec_runtime.Encode.string, param);
        }, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Eval", function (param) {
          return Atdgen_codec_runtime.Encode.tuple2(write__t, Atdgen_codec_runtime.Encode.string, param);
        }, x[1]);
      }
    } else if (variant >= 295523485) {
      return Atdgen_codec_runtime.Encode.constr1("Blob_id", write__blob_id, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Job_id", write__job_id, x[1]);
    }
  });
}

function read_error(read__blob_id, read__job_id, read__t, read__ty) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Blob_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Blob_id */
        [295523485, x]
      );
    }, read__blob_id, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Job_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Job_id */
        [-1057852867, x]
      );
    }, read__job_id, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Eval",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Eval */
        [771069884, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__t, Atdgen_codec_runtime.Decode.string, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Type",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Type */
        [937565914, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple3(read__t, function (param) {
        return Atdgen_codec_runtime.Decode.nullable(read__ty, param);
      }, Atdgen_codec_runtime.Decode.string, param);
    }, param);
  }]],
  /* [] */
  0]]]]);
}

function write__1(param) {
  return Atdgen_codec_runtime.Encode.contramap(Char_wrap$SolvuuLang0.unwrap, Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.map(Char_wrap$SolvuuLang0.wrap, Atdgen_codec_runtime.Decode.string, param);
}

function write_t(write__date, write__time, write__blob_id, write__job_id, write__t, write__label, write__map, write__var, write__term_id, write__type0, write__env, write__intrinsic, write__meta, write__dir) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (typeof x === "number") {
      if (x !== 870828711) {
        if (x >= 914889282) {
          return Atdgen_codec_runtime.Encode.constr0("Root");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Function");
        }
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Null");
      }
    } else {
      var variant = x[0];

      if (variant >= 89433895) {
        if (variant >= 748194550) {
          if (variant >= 858945253) {
            if (variant >= 925978388) {
              if (variant >= 936769581) {
                return Atdgen_codec_runtime.Encode.constr1("Time", write__time, x[1]);
              } else {
                return Atdgen_codec_runtime.Encode.constr1("Some", write__t, x[1]);
              }
            } else if (variant >= 925483562) {
              return Atdgen_codec_runtime.Encode.constr1("Sexp", Atdgen_codec_runtime.Encode.string, x[1]);
            } else {
              return Atdgen_codec_runtime.Encode.constr1("Meta", function (param) {
                return Atdgen_codec_runtime.Encode.tuple2(write__meta, write__t, param);
              }, x[1]);
            }
          } else if (variant >= 847309489) {
            if (variant >= 848054398) {
              return Atdgen_codec_runtime.Encode.constr1("List", function (param) {
                return Atdgen_codec_runtime.Encode.list(write__t, param);
              }, x[1]);
            } else {
              return Atdgen_codec_runtime.Encode.constr1("Record", write__map, x[1]);
            }
          } else if (variant >= 758940238) {
            return Atdgen_codec_runtime.Encode.constr1("Date", write__date, x[1]);
          } else {
            return Atdgen_codec_runtime.Encode.constr1("Char", write__1, x[1]);
          }
        } else if (variant >= 365180284) {
          if (variant >= 669191267) {
            if (variant >= 737456202) {
              return Atdgen_codec_runtime.Encode.constr1("Bool", Atdgen_codec_runtime.Encode.bool, x[1]);
            } else {
              return Atdgen_codec_runtime.Encode.constr1("Future", write_future(write__blob_id, write__job_id), x[1]);
            }
          } else if (variant >= 521729689) {
            return Atdgen_codec_runtime.Encode.constr1("If_then_else", function (param) {
              return Atdgen_codec_runtime.Encode.tuple3(write__t, write__t, write__t, param);
            }, x[1]);
          } else {
            return Atdgen_codec_runtime.Encode.constr1("Float", Atdgen_codec_runtime.Encode.$$float, x[1]);
          }
        } else if (variant !== 106380200) {
          if (variant >= 295523485) {
            return Atdgen_codec_runtime.Encode.constr1("Blob_id", write__blob_id, x[1]);
          } else {
            return Atdgen_codec_runtime.Encode.constr1("Lambda", function (param) {
              return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, write__t, param);
            }, x[1]);
          }
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Error", write_error(write__blob_id, write__job_id, write__t, write__type0), x[1]);
        }
      } else if (variant >= -37599172) {
        if (variant >= 3503881) {
          if (variant >= 4298439) {
            if (variant >= 4300231) {
              return Atdgen_codec_runtime.Encode.constr1("Viz", write__t, x[1]);
            } else {
              return Atdgen_codec_runtime.Encode.constr1("Var", write__var, x[1]);
            }
          } else if (variant >= 3654863) {
            return Atdgen_codec_runtime.Encode.constr1("Int", Atdgen_codec_runtime.Encode.$$int, x[1]);
          } else {
            return Atdgen_codec_runtime.Encode.constr1("Ffi", Atdgen_codec_runtime.Encode.string, x[1]);
          }
        } else if (variant !== 3257473) {
          if (variant >= 3405101) {
            return Atdgen_codec_runtime.Encode.constr1("Dir", write__dir, x[1]);
          } else {
            return Atdgen_codec_runtime.Encode.constr1("Ascription", function (param) {
              return Atdgen_codec_runtime.Encode.tuple2(write__t, write__type0, param);
            }, x[1]);
          }
        } else {
          return Atdgen_codec_runtime.Encode.constr1("App", function (param) {
            return Atdgen_codec_runtime.Encode.tuple2(write__t, write__t, param);
          }, x[1]);
        }
      } else if (variant >= -964680357) {
        if (variant >= -452137819) {
          if (variant >= -216449554) {
            return Atdgen_codec_runtime.Encode.constr1("Term_id", write__term_id, x[1]);
          } else {
            return Atdgen_codec_runtime.Encode.constr1("Intrinsic", write__intrinsic, x[1]);
          }
        } else if (variant >= -522825178) {
          return Atdgen_codec_runtime.Encode.constr1("Solvuu", Atdgen_codec_runtime.Encode.string, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Closure", function (param) {
            return Atdgen_codec_runtime.Encode.tuple2(write__env, write__t, param);
          }, x[1]);
        }
      } else if (variant !== -1019462983) {
        if (variant >= -976970511) {
          return Atdgen_codec_runtime.Encode.constr1("String", Atdgen_codec_runtime.Encode.string, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Job_id", write__job_id, x[1]);
        }
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Project", write__label, x[1]);
      }
    }
  });
}

function read_t(read__date, read__time, read__blob_id, read__job_id, read__t, read__label, read__map, read__var, read__term_id, read__type0, read__env, read__intrinsic, read__meta, read__dir) {
  var partial_arg = read_error(read__blob_id, read__job_id, read__t, read__type0);
  var partial_arg$1 = read_future(read__blob_id, read__job_id);
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Int",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int */
        [3654863, x]
      );
    }, Atdgen_codec_runtime.Decode.$$int, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float */
        [365180284, x]
      );
    }, Atdgen_codec_runtime.Decode.$$float, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Char",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Char */
        [748194550, x]
      );
    }, read__1, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Bool",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Bool */
        [737456202, x]
      );
    }, Atdgen_codec_runtime.Decode.bool, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["String",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `String */
        [-976970511, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Date",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Date */
        [758940238, x]
      );
    }, read__date, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Time",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Time */
        [936769581, x]
      );
    }, read__time, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Null",
  /* `Single */
  [-306849112,
  /* Null */
  870828711]],
  /* :: */
  [
  /* tuple */
  ["Some",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Some */
        [925978388, x]
      );
    }, read__t, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["List",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `List */
        [848054398, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.list(read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Root",
  /* `Single */
  [-306849112,
  /* Root */
  914889282]],
  /* :: */
  [
  /* tuple */
  ["Record",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Record */
        [847309489, x]
      );
    }, read__map, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Project",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Project */
        [-1019462983, x]
      );
    }, read__label, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Var",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Var */
        [4298439, x]
      );
    }, read__var, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Lambda",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Lambda */
        [89433895, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["App",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `App */
        [3257473, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__t, read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["If_then_else",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `If_then_else */
        [521729689, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple3(read__t, read__t, read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Error",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Error */
        [106380200, x]
      );
    }, partial_arg, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Blob_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Blob_id */
        [295523485, x]
      );
    }, read__blob_id, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Job_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Job_id */
        [-1057852867, x]
      );
    }, read__job_id, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Term_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Term_id */
        [-216449554, x]
      );
    }, read__term_id, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Ascription",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Ascription */
        [-37599172, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__t, read__type0, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Closure",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Closure */
        [-964680357, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__env, read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Ffi",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Ffi */
        [3503881, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Future",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Future */
        [669191267, x]
      );
    }, partial_arg$1, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Intrinsic",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Intrinsic */
        [-452137819, x]
      );
    }, read__intrinsic, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Meta",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Meta */
        [858945253, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__meta, read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Dir",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Dir */
        [3405101, x]
      );
    }, read__dir, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Function",
  /* `Single */
  [-306849112,
  /* Function */
  -301701320]],
  /* :: */
  [
  /* tuple */
  ["Sexp",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Sexp */
        [925483562, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Solvuu",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Solvuu */
        [-522825178, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Viz",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Viz */
        [4300231, x]
      );
    }, read__t, param);
  }]],
  /* [] */
  0]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);
}

function write_scalar(write__date, write__time) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant >= 737456202) {
      if (variant >= 758940238) {
        if (variant >= 936769581) {
          return Atdgen_codec_runtime.Encode.constr1("Time", write__time, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Date", write__date, x[1]);
        }
      } else if (variant >= 748194550) {
        return Atdgen_codec_runtime.Encode.constr1("Char", write__1, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Bool", Atdgen_codec_runtime.Encode.bool, x[1]);
      }
    } else if (variant !== 3654863) {
      if (variant >= 365180284) {
        return Atdgen_codec_runtime.Encode.constr1("Float", Atdgen_codec_runtime.Encode.$$float, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("String", Atdgen_codec_runtime.Encode.string, x[1]);
      }
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Int", Atdgen_codec_runtime.Encode.$$int, x[1]);
    }
  });
}

function read_scalar(read__date, read__time) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Int",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int */
        [3654863, x]
      );
    }, Atdgen_codec_runtime.Decode.$$int, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float */
        [365180284, x]
      );
    }, Atdgen_codec_runtime.Decode.$$float, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Char",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Char */
        [748194550, x]
      );
    }, read__1, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Bool",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Bool */
        [737456202, x]
      );
    }, Atdgen_codec_runtime.Decode.bool, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["String",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `String */
        [-976970511, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Date",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Date */
        [758940238, x]
      );
    }, read__date, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Time",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Time */
        [936769581, x]
      );
    }, read__time, param);
  }]],
  /* [] */
  0]]]]]]]);
}

function write_record(write__map) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (typeof x === "number") {
      return Atdgen_codec_runtime.Encode.constr0("Root");
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Record", write__map, x[1]);
    }
  });
}

function read_record(read__map) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Root",
  /* `Single */
  [-306849112,
  /* Root */
  914889282]],
  /* :: */
  [
  /* tuple */
  ["Record",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Record */
        [847309489, x]
      );
    }, read__map, param);
  }]],
  /* [] */
  0]]);
}

function write_project(write__label) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Project", write__label, x[1]);
  });
}

function read_project(read__label) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Project",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Project */
        [-1019462983, x]
      );
    }, read__label, param);
  }]],
  /* [] */
  0]);
}

function write_nullable_(write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (typeof x === "number") {
      return Atdgen_codec_runtime.Encode.constr0("Null");
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Some", write__t, x[1]);
    }
  });
}

function read_nullable_(read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Null",
  /* `Single */
  [-306849112,
  /* Null */
  870828711]],
  /* :: */
  [
  /* tuple */
  ["Some",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Some */
        [925978388, x]
      );
    }, read__t, param);
  }]],
  /* [] */
  0]]);
}

function write_meta(write__meta, write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Meta", function (param) {
      return Atdgen_codec_runtime.Encode.tuple2(write__meta, write__t, param);
    }, x[1]);
  });
}

function read_meta(read__meta, read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Meta",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Meta */
        [858945253, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__meta, read__t, param);
    }, param);
  }]],
  /* [] */
  0]);
}

function write_list_(write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("List", function (param) {
      return Atdgen_codec_runtime.Encode.list(write__t, param);
    }, x[1]);
  });
}

function read_list_(read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["List",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `List */
        [848054398, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.list(read__t, param);
    }, param);
  }]],
  /* [] */
  0]);
}

function write_intrinsic(write__intrinsic) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Intrinsic", write__intrinsic, x[1]);
  });
}

function read_intrinsic(read__intrinsic) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Intrinsic",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Intrinsic */
        [-452137819, x]
      );
    }, read__intrinsic, param);
  }]],
  /* [] */
  0]);
}

function write_extern(write__blob_id, write__job_id) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= 295523485) {
      return Atdgen_codec_runtime.Encode.constr1("Blob_id", write__blob_id, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Job_id", write__job_id, x[1]);
    }
  });
}

function read_extern(read__blob_id, read__job_id) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Blob_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Blob_id */
        [295523485, x]
      );
    }, read__blob_id, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Job_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Job_id */
        [-1057852867, x]
      );
    }, read__job_id, param);
  }]],
  /* [] */
  0]]);
}

function write_dir(write__dir) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Dir", write__dir, x[1]);
  });
}

function read_dir(read__dir) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Dir",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Dir */
        [3405101, x]
      );
    }, read__dir, param);
  }]],
  /* [] */
  0]);
}

function write_container(write__t, write__map) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (typeof x === "number") {
      if (x >= 914889282) {
        return Atdgen_codec_runtime.Encode.constr0("Root");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Null");
      }
    } else {
      var variant = x[0];

      if (variant !== 848054398) {
        if (variant >= 925978388) {
          return Atdgen_codec_runtime.Encode.constr1("Some", write__t, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Record", write__map, x[1]);
        }
      } else {
        return Atdgen_codec_runtime.Encode.constr1("List", function (param) {
          return Atdgen_codec_runtime.Encode.list(write__t, param);
        }, x[1]);
      }
    }
  });
}

function read_container(read__t, read__map) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Null",
  /* `Single */
  [-306849112,
  /* Null */
  870828711]],
  /* :: */
  [
  /* tuple */
  ["Some",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Some */
        [925978388, x]
      );
    }, read__t, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["List",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `List */
        [848054398, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.list(read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Root",
  /* `Single */
  [-306849112,
  /* Root */
  914889282]],
  /* :: */
  [
  /* tuple */
  ["Record",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Record */
        [847309489, x]
      );
    }, read__map, param);
  }]],
  /* [] */
  0]]]]]);
}

function write_conditional(write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("If_then_else", function (param) {
      return Atdgen_codec_runtime.Encode.tuple3(write__t, write__t, write__t, param);
    }, x[1]);
  });
}

function read_conditional(read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["If_then_else",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `If_then_else */
        [521729689, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple3(read__t, read__t, read__t, param);
    }, param);
  }]],
  /* [] */
  0]);
}

function write_closure(write__env, write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Closure", function (param) {
      return Atdgen_codec_runtime.Encode.tuple2(write__env, write__t, param);
    }, x[1]);
  });
}

function read_closure(read__env, read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Closure",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Closure */
        [-964680357, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__env, read__t, param);
    }, param);
  }]],
  /* [] */
  0]);
}

function write_blob_id(write__blob_id) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Blob_id", write__blob_id, x[1]);
  });
}

function read_blob_id(read__blob_id) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Blob_id",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Blob_id */
        [295523485, x]
      );
    }, read__blob_id, param);
  }]],
  /* [] */
  0]);
}

function write_ascription(write__t, write__u) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Ascription", function (param) {
      return Atdgen_codec_runtime.Encode.tuple2(write__t, write__u, param);
    }, x[1]);
  });
}

function read_ascription(read__t, read__u) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Ascription",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Ascription */
        [-37599172, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__t, read__u, param);
    }, param);
  }]],
  /* [] */
  0]);
}

function write_arrow(write__var, write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant !== 4298439) {
      if (variant >= 89433895) {
        return Atdgen_codec_runtime.Encode.constr1("Lambda", function (param) {
          return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, write__t, param);
        }, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("App", function (param) {
          return Atdgen_codec_runtime.Encode.tuple2(write__t, write__t, param);
        }, x[1]);
      }
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Var", write__var, x[1]);
    }
  });
}

function read_arrow(read__var, read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Var",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Var */
        [4298439, x]
      );
    }, read__var, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Lambda",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Lambda */
        [89433895, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, read__t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["App",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `App */
        [3257473, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__t, read__t, param);
    }, param);
  }]],
  /* [] */
  0]]]);
}

function write_app(write__f, write__x) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("App", function (param) {
      return Atdgen_codec_runtime.Encode.tuple2(write__f, write__x, param);
    }, x[1]);
  });
}

function read_app(read__f, read__x) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["App",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `App */
        [3257473, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__f, read__x, param);
    }, param);
  }]],
  /* [] */
  0]);
}

export { read_var, write_var, read_uri, write_uri, read_future, write_future, read_error, write_error, read_t, write_t, read_scalar, write_scalar, read_record, write_record, read_project, write_project, read_nullable_, write_nullable_, read_meta, write_meta, read_list_, write_list_, read_intrinsic, write_intrinsic, read_extern, write_extern, read_dir, write_dir, read_container, write_container, read_conditional, write_conditional, read_closure, write_closure, read_blob_id, write_blob_id, read_ascription, write_ascription, read_arrow, write_arrow, read_app, write_app };
/* No side effect */